import React, {useState, useEffect, useRef} from 'react';
import { CircularProgress } from '@mui/material';
import ColorUtils from '../utils/colors'
import localization from '../utils/localization'
import ToolsUtils from '../utils/tools'
import easypassLogo from '../assets/logo_256.png'
import toast from 'react-hot-toast'
import { initializePaddle } from '@paddle/paddle-js'

function Paddle(props) {
  const [appID, setAppID] = useState(0)
  const [step, setStep] = useState(0)
  const paddleRef = useRef(null)

  useEffect(() => {
    let appID = parseInt(ToolsUtils.getParameterByName("app_id"))
    let account = ToolsUtils.getParameterByName("account")
    
    // Only support EasyPass
    if (!appID || appID !== 1) {
      setStep(1)
      return
    }

    setAppID(appID)

    async function initAndOpenPaddle() {
      try {
        if (!paddleRef.current) {
          paddleRef.current = await initializePaddle({
            token: 'live_f7aab74c4400e53a2c9b8bb10cb',
            eventCallback: (event) => {
              if (event.name === 'checkout.completed') {
                setStep(2)
                toast.success(localization.strings.payed)
              }
            },
          })
        }

        paddleRef.current?.Checkout.open({
          settings: {
            displayMode: 'overlay',
            theme: 'light',
            locale: localization.language.lang === 'zh' ? 'zh-Hans' : 'en',
            allowLogout: false,
          },
          items: [
            {
              priceId: 'pri_01kte138dn5n3884agggdpmnjr',
              quantity: 1,
            },
          ],
          customer: {
            email: account || '',
          },
          customData: {
            account: account || '',
          },
        })
        setStep(3)
      } catch (e) {
        console.error('Paddle init error:', e)
        toast.error(localization.strings.networkErr)
        setStep(1)
      }
    }

    initAndOpenPaddle()
  }, [])

  return <div style={{
    backgroundColor: ColorUtils.white,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  }}>
    {
      step === 0 && (
        <>
          <CircularProgress size="5rem" style={{
            display: 'block',
            margin: '0rem auto',
          }}/>
          <div style={{
            textAlign: 'center',
            color: ColorUtils.textColor,
            marginTop: '1rem',
            fontSize: '1.2rem',
          }}>{localization.strings.loading}</div>
        </>
      )
    }
    {
      step === 1 && (
        <>
          <h1 style={{
            textAlign: 'center',
            fontSize: '5rem',
          }}>
            4 0 4
          </h1>
          <h2 style={{
            textAlign: 'center',
          }}>{localization.strings.pageNotFound}...</h2>
        </>
      )
    }
    {
      step === 2 && (
        <>
          <div style={{
            textAlign: 'center',
            margin: '0rem 0rem 1rem',
            fontSize: '5rem',
          }}>
            <img src={easypassLogo}/>
          </div>
          <h2 style={{
            textAlign: 'center',
          }}>{localization.strings.hasPaidTitle}</h2>
        </>
      )
    }
    {
      step === 3 && (
        <>
          <div style={{
            textAlign: 'center',
            margin: '0rem 0rem 1rem',
            fontSize: '5rem',
          }}>
            <img src={easypassLogo}/>
          </div>
          <h2 style={{
            textAlign: 'center',
          }}>{localization.strings.easypassPaddlePayTitle}</h2>
        </>
      )
    }
  </div>
}

export default Paddle
